module.exports = __webpack_public_path__ + "static/media/objects_11.abc560f0.svg";